import { createStore } from 'stimulus-store';

export const deviceTypeFilterOptionsStore = createStore({
    name: 'deviceTypeFilterOptionsStore',
    type: Array,
    initialValue: []
});
